export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11976.f847a43d.jpg";